import {IRouteStore} from '../../../router/routing.infra';
import {getDashboardStores} from '../dashboard.stores';
import {EntryController} from '../../../components/entry/entry/Entry.controller';

export interface IEntryStore extends IRouteStore {
    entryController: EntryController;
}

export class EntryStore implements IEntryStore {
    public entryController: EntryController;

    constructor() {
        const ds = getDashboardStores();
        this.entryController = new EntryController(
            ds.dashboardState.accountData,
            ds.dashboardState.currentUser,
            ds.wizardState
        );
    }

    dispose(): void {}
}
